import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { UserContext } from "../context/UserContext";
import job from "../Assests/Images/jobexplore.png";
import event from "../Assests/Images/eventexplore.png";
import classified from "../Assests/Images/classifiedexplore.jpg";
import offers from "../Assests/Images/offersexplore.png";
import services from "../Assests/Images/servicesexplore.png";
import API_BASE_URL from "../../src/config";

const Explore = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const latestConfigRef = useRef(null);
  const [, forceRender] = useState(false);

  const cards = [
    {
      title: "Jobs",
      description: "Find various job opportunities in your preferred city based on your interests.Discover roles that match your passion and skillset.Start your career journey in a place that inspires you.",
      imageSrc: job,
      bgColor: "rgb(218, 250, 250)",
      link: "/jobs",
    },
    {
      title: "Services",
      description: "Discover a wide range of services offered by professionals. From IT support to home maintenance, find what you need. Easily connect with trusted local service providers.",
      imageSrc: services,
      bgColor: "rgb(223, 223, 253)",
      link: "/services",
    },
    {
      title: "Events",
      description: "Never miss out on what's happening around you. Find workshops, meetups, and community events. Stay engaged and make meaningful connections.",
      imageSrc: event,
      bgColor: "rgb(253, 237, 251)",
      link: "/events",
    },
    {
      title: "Offers",
      description: "Unlock great deals and limited-time promotions. Browse discounts for shopping, services, and more. Save money while enjoying exclusive offers.",
      imageSrc: offers,
      bgColor: "rgb(252, 244, 220)",
      link: "/offers",
    },
    {
      title: "Classifieds",
      description: "Explore items for sale or post your own listings. Find furniture, electronics, vehicles, and more. A simple way to buy, sell, or trade locally.",
      imageSrc: classified,
      bgColor: "rgb(227, 253, 209)",
      link: "/classifieds",
    },
  ];

  const enabledFeatures = cards.filter((card) => {
    const key = card.title.toLowerCase();
    return latestConfigRef.current?.[key];
  });

  const handleExploreClick = (link) => {
    navigate(link);
  };

  useEffect(() => {
    const fetchFeatureSettings = async () => {
      try {
        console.log("🔍 Checking user context:", user);

        if (user) {
          const response = await fetch(`${API_BASE_URL}/users`);
          const data = await response.json();
          const currentUser = data.users.find((u) => u.id === Number(user.id));

          if (!currentUser) {
            console.error("🚨 User not found in /users API response.");
            return;
          }

          console.log("✅ Matched user from API:", currentUser);

          const config = {
            jobs: currentUser.show_jobs,
            services: currentUser.show_services,
            events: currentUser.show_events,
            offers: currentUser.show_offers,
            classifieds: currentUser.show_classifieds,
            ads: currentUser.show_ads,
          };

          latestConfigRef.current = config;
        } else {
          const response = await fetch(`${API_BASE_URL}/admin-settings`);
          const data = await response.json();

          const latestConfig = data.configuration_settings.reduce(
            (latest, current) => (current.id > latest.id ? current : latest),
            data.configuration_settings[0]
          );

          const config = {
            jobs: latestConfig.jobs === true,
            services: latestConfig.services === true,
            events: latestConfig.events === true,
            offers: latestConfig.offers === true,
            classifieds: latestConfig.classifieds === true,
            ads: latestConfig.ads === true,
          };

          latestConfigRef.current = config;
        }

        forceRender((prev) => !prev);
      } catch (error) {
        console.error("❌ Failed to fetch feature settings:", error);
      }
    };

    fetchFeatureSettings();
  }, [user]);

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        {latestConfigRef.current ? (
          enabledFeatures.length > 0 ? (
            enabledFeatures.map((card, index) => (
              <div style={styles.aBox} key={index}>
                <div style={styles.imgContainer}>
                  <img
                    src={card.imageSrc}
                    alt={card.title}
                    style={styles.img}
                  />
                </div>
                <div
                  style={{
                    ...styles.textContainer,
                    backgroundColor: card.bgColor,
                  }}
                >
                  <h3 style={styles.textHeading}>{card.title}</h3>
                  <div>{card.description}</div>
                  <Button
                    variant="contained"
                    sx={styles.muiButton}
                    onClick={() => handleExploreClick(card.link)}
                  >
                    Explore More
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <Typography variant="h6" textAlign="center" mt={4}>
              No opportunities are currently enabled.
            </Typography>
          )
        ) : (
          <Typography textAlign="center" mt={4}>
            Loading your Opportunities based on Interests...
          </Typography>
        )}
      </div>
    </div>
  );
};

const styles = {
  body: {
    textAlign: "center",
    padding: "30px",
    background: "rgb(255, 255, 255)",
    fontFamily: "Arial",
    minHeight: "100vh",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
    justifyItems: "center",
    padding: "0 40px",
  },
  aBox: {
    width: "300px",
    textAlign: "center",
  },
  imgContainer: {
    height: "260px",
    width: "260px",
    overflow: "hidden",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "20px auto",
    backgroundColor: "#e0e0e0",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
  },
  textContainer: {
    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
    padding: "140px 20px 20px 20px",
    borderRadius: "20px",
    margin: "-140px 0px 0px 0px",
    lineHeight: "20px",
    fontSize: "15px",
  },
  textHeading: {
    margin: "20px 0px 10px 0px",
    color: "#42326e",
    fontSize: "25px",
    fontWeight: "bold",
  },
  muiButton: {
    backgroundColor: "#42326e",
    color: "white",
    marginTop: "10px",
    padding: "10px 20px",
    fontSize: "14px",
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
  },
};

export default Explore;
